import * as users from './users';
import * as programs from './programs';
import * as patients from './patients';
import * as devices from './devices';
import * as activityLogs from './activityLogs';
import * as reports from './reports';
import * as dashboard from './dashboard';
import * as triage from './triage';
import * as notes from './notes';
import * as insurances from './insurances';
import * as medications from './medications';
import * as auditLogs from './auditLogs';
import * as auth from './auth';
import * as patientNotificationRules from './patientNotificationRules';
import * as mobileUsers from './mobileUsers';
import * as notifications from './notifications';
import * as icd10Codes from './icd10Codes';
import * as carePlanIcd10Codes from './carePlanIcd10Codes';
import * as carePlanMedications from './carePlanMedications';
import * as carePlanHospitalizations from './carePlanHospitalizations';
import * as carePlanMedicalNotes from './carePlanMedicalNotes';
import * as carePlanGoals from './carePlanGoals';
import * as carePlanInterventions from './carePlanInterventions';
import * as tableCustomizations from './tableCustomizations';
import * as deviceHistoryLogs from './deviceHistoryLogs';
import * as readings from './readings';
import * as templates from './templates';
import * as carePlans from './carePlans';
import * as storageFiles from './storageFiles';
import * as mihin from './mihin';
import * as bloodPressureReadings from './bloodPressureReadings';
import * as hospital from './hospital';
import * as attendingPhysicians from './attendingPhysicians';
import * as patientMonitoringPauses from './patientMonitoringPauses';

export default {
  users,
  programs,
  patients,
  devices,
  activityLogs,
  reports,
  dashboard,
  triage,
  notes,
  insurances,
  medications,
  auditLogs,
  auth,
  patientNotificationRules,
  mobileUsers,
  notifications,
  icd10Codes,
  carePlanIcd10Codes,
  carePlanMedications,
  carePlanHospitalizations,
  carePlanGoals,
  carePlanMedicalNotes,
  carePlanInterventions,
  tableCustomizations,
  deviceHistoryLogs,
  readings,
  templates,
  carePlans,
  storageFiles,
  mihin,
  bloodPressureReadings,
  hospital,
  attendingPhysicians,
  patientMonitoringPauses,
};
